/**
 * 全局有遮罩的 Loading 组件管理
 * 基于 van-overlay + 自定义 Loading 组件，支持遮罩层
 */

import { createApp } from 'vue'
import AppLoadingOverlay from '@/components/feedback/AppLoadingOverlay.vue'

let overlayInstance: ReturnType<typeof createApp> | null = null
let overlayComponent: InstanceType<typeof AppLoadingOverlay> | null = null
let container: HTMLElement | null = null

const mountOverlay = () => {
  if (overlayInstance) return

  container = document.createElement('div')
  container.setAttribute('id', 'app-loading-overlay-root')
  document.body.appendChild(container)

  overlayInstance = createApp(AppLoadingOverlay)
  overlayComponent = overlayInstance.mount(container) as InstanceType<typeof AppLoadingOverlay>
}

const unmountOverlay = () => {
  if (overlayInstance) {
    overlayInstance.unmount()
    overlayInstance = null
    overlayComponent = null
  }
  if (container) {
    document.body.removeChild(container)
    container = null
  }
}

export const showLoadingOverlay = (message: string = '') => {
  mountOverlay()
  overlayComponent?.show(message)
}

export const closeLoadingOverlay = () => {
  overlayComponent?.hide()
  // 延迟卸载，等待动画完成
  setTimeout(() => {
    unmountOverlay()
  }, 300)
}
